const importAll = (r) => r.keys().map(r)
importAll(require.context('images/', true, /\.(png|jpe?g|svg|ico|svg)$/))
